import api from "@/lib/api";

export function trackTrailer(source, action) {
    try {
        api.post("/analytics/trailer", {
            source,
            action,
            referrer: typeof document !== "undefined" ? document.referrer || null : null,
        }).catch(() => {});
    } catch {
        // Analytics must never break the user flow.
    }
}
